/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Analyze_DataInputs */



/**
* | output |
* | --- |
* | "Analyze a spreadsheet with me" |
*
* @param {Uno_Welcome_Suggestion_Analyze_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_analyze_data = /** @type {((inputs?: Uno_Welcome_Suggestion_Analyze_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Analyze_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Analysiere mit mir eine Tabelle")
	return /** @type {LocalizedString} */ ("Analyze a spreadsheet with me")
});